import { Box } from '@mui/material';
import { styled } from '@mui/material';

import { COLORS } from '~/styles/colors';
import { getScalValue } from '~/utils/common';

// Modal container styling
export const ModalContainer = styled(Box)(() => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '475px',
  backgroundColor: COLORS.white,
  boxShadow: '0 0 20px 0 rgba(0, 0, 0, 0.05)',
  borderRadius: '20px',
  padding: '40px',
  display: 'flex',
  flexDirection: 'column',
}));

// Uploaded image container
export const StyledUploadedImageContainer = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '172px',
  width: '100%',
  border: `2px dashed ${COLORS.primary}`,
  borderRadius: '20px',
  backgroundColor: COLORS.blue50,
}));

// Define custom props for image style
interface StyledUploadedImageProps {
  $rotate: number;
  $zoom: number;
  $roundness: string | number;
}

// Styled uploaded image
export const StyledUploadedImage = styled('img')<StyledUploadedImageProps>(({ $rotate, $zoom, $roundness }) => ({
  height: 120,
  width: 120,
  objectFit: 'cover',
  transform: `rotate(${$rotate}deg) scale(${getScalValue($zoom)})`,
  borderRadius: $roundness,
}));
